import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { IAsyncData } from "../../../../core/models";
import { IAppReduxState } from "../../../../redux/store";
import { ROUTES } from "../../../../routes";
import { IClientForm } from "../../data/entities";
import { ClientForm } from "../components/form";
import { clientRedux } from "../state/state";

export const ClientCreatePage: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const onSubmit = async (values: IClientForm): Promise<void> => {
    await dispatch(clientRedux.actions.create(values));
    history.push(ROUTES.client);
  };

  const createClientBranch = useSelector<IAppReduxState, IAsyncData<any>>((state) => state.client.create);

  return <ClientForm branch={createClientBranch} onSubmit={onSubmit} initialData={null} submitTitle="Create" />;
};
